import { getStore } from '../axiosInstance';

export const setupRequestInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      // Get token from Redux store or localStorage as fallback
      const store = getStore();
      let token = null;

      if (store) {
        const state = store.getState();
        token = state.auth?.token;
      }

      // Fallback to localStorage if store not available yet
      if (!token) {
        token = localStorage.getItem('auth_token');
      }

      // Add Authorization header if token exists
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Add request timestamp for debugging
      config.metadata = { startTime: new Date() };

      // Log request in development
      if (process.env.NODE_ENV === 'development') {
      }

      return config;
    },
    (error) => {
      console.error('[API Request Error]', error);
      return Promise.reject(error);
    }
  );
};
